import { useField, useFormikContext } from "formik"
import { EditorProvider } from "@tiptap/react"
import StarterKit from "@tiptap/starter-kit"
import Link from "@tiptap/extension-link"
import MenuBar from "./MenuBar"

interface FormikTiptapProps {
  name: string
}

const extensions = [
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: false,
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false,
    },
  }),
  Link.configure({
    openOnClick: false,
  }),
]

const FormikTiptap = ({ name }: FormikTiptapProps) => {
  const { setFieldValue } = useFormikContext()
  const [field] = useField(name)

  return (
    <EditorProvider
      slotBefore={<MenuBar />}
      extensions={extensions}
      onUpdate={({ editor }) => {
        const html = editor.getHTML()
        setFieldValue(name, html)
      }}
      content={field.value}
    ></EditorProvider>
  )
}

export default FormikTiptap
